import {useEffect} from 'react';
import {useSelectedLocale} from './selected-locale';
import {isRtlLocale} from './is-rtl-locale';

/**
 * The initial page load already gets the correct dir="rtl|ltr" from the
 * server (see framework.blade.php + RtlLanguages.php), but changing the
 * language from the LocaleSwitcher does not reload the page, so we also
 * need to keep <html dir/lang> in sync on the client whenever the
 * selected locale changes.
 */
export function useSyncDocumentDirection() {
  const {localeCode} = useSelectedLocale();

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.dir = isRtlLocale(localeCode) ? 'rtl' : 'ltr';
    document.documentElement.lang = localeCode;
  }, [localeCode]);
}
